// src/pages/OvertimeApprovalsPage.tsx
// Refatorado com a nova identidade visual (Tailwind + UI kit)

import React, { useContext, useState } from 'react';
import { AuthContext } from '../contexts/AuthAdapter';
import { SidebarPortal } from '../../shared/components/SidebarPortal';
import OvertimeApprovalDashboard from '../components/OvertimeApprovalDashboard';
import CreateProjectModal from '../components/CreateProjectModal';
import { Button, Card, EmptyState } from '../../shared/components/ui';
import './OvertimeApprovalsPage.css';

const OvertimeApprovalsPage: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);

  // Check if user can create projects (managers, directors, admins)
  const canCreateProject = user?.role && (
    ['manager', 'director', 'admin', 'project manager'].includes(user.role.toLowerCase()) ||
    user.role.toLowerCase().includes('manager') ||
    user.role.toLowerCase().includes('director') ||
    user.role.toLowerCase().includes('admin') ||
    user.role === 'Project Manager'
  );

  // Handle project creation
  const handleProjectCreated = async () => {
    setIsProjectModalOpen(false);
  };

  // Check if user has permission to access overtime approvals
  const canAccessOvertime = user?.role && (
    ['supervisor', 'manager', 'director', 'admin'].includes(user.role.toLowerCase()) ||
    user.role.toLowerCase().includes('supervisor') ||
    user.role.toLowerCase().includes('manager') ||
    user.role.toLowerCase().includes('director')
  );

  if (!canAccessOvertime) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-8">
        <Card padding="lg" className="w-full max-w-md text-center">
          <EmptyState
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            }
            title="Acesso Negado"
            description="Apenas supervisores e gerentes podem acessar a aprovação de horas extras."
          />
        </Card>
      </div>
    );
  }

  return (
    <>
      {canCreateProject && (
        <SidebarPortal>
          <Button
            fullWidth
            onClick={() => setIsProjectModalOpen(true)}
            className="mb-4"
          >
            Novo Projeto
          </Button>
        </SidebarPortal>
      )}
      <div className="p-8">
        <OvertimeApprovalDashboard
          onApprovalAction={() => {
            // Optional: Add any refresh logic here if needed
          }}
        />
      </div>

      {/* Create Project Modal */}
      {isProjectModalOpen && (
        <CreateProjectModal
          onClose={() => setIsProjectModalOpen(false)}
          onProjectCreated={handleProjectCreated}
        />
      )}
    </>
  );
};

export default OvertimeApprovalsPage;
